import ky from "ky";
import RestEndpointsEnum from "../models/RestEndpointsEnum";
import { buildRestUrl, buildRestUrlWithQuery, buildAuthHeadersForKy } from "./RestService";
import IUserUI from "../models/IUserUI";
import ISupplierModel from "../models/ISupplierModel";
import IVendorModel from "../models/IVendorModel";
import { IAdvanceSerialsDTO } from "../models/DTO/Production/IProductionRequestDTO";
import {
    IAdvanceSerialsResponseDTO,
    IGetSerialsByStepResponseDTO,
    ISerialWorkflowHistoryResponseDTO,
    IProductionDashboardResponseDTO,
} from "../models/DTO/Production/IProductionResponseDTO";

export interface ProductionAuthContext {
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    vendorModel: IVendorModel;
}

function getHeaders(ctx: ProductionAuthContext): HeadersInit {
    return buildAuthHeadersForKy({
        userModel: ctx.userModel,
        supplierModel: ctx.supplierModel,
        vendorModel: ctx.vendorModel,
    });
}

export async function getSerialsByStep(
    ctx: ProductionAuthContext,
    stepId: number,
    page: number,
    limit: number,
    search?: string
): Promise<IGetSerialsByStepResponseDTO> {
    const trimmedSearch = search?.trim();
    const url = buildRestUrlWithQuery({
        endpoint: RestEndpointsEnum.ProductionSerials,
        query: {
            serial_workflow_step_id: stepId,
            page,
            limit,
            ...(trimmedSearch ? { search: trimmedSearch } : {}),
        },
    });
    return ky.get(url, { headers: getHeaders(ctx) }).json<IGetSerialsByStepResponseDTO>();
}

export async function advanceSerials(ctx: ProductionAuthContext, body: IAdvanceSerialsDTO): Promise<IAdvanceSerialsResponseDTO> {
    const url = buildRestUrl({ endpoint: RestEndpointsEnum.ProductionAdvance });
    return ky.post(url, { json: body, headers: getHeaders(ctx) }).json<IAdvanceSerialsResponseDTO>();
}

export async function getProductionDashboard(ctx: ProductionAuthContext): Promise<IProductionDashboardResponseDTO> {
    const url = buildRestUrl({ endpoint: RestEndpointsEnum.ProductionDashboard });
    return ky.get(url, { headers: getHeaders(ctx) }).json<IProductionDashboardResponseDTO>();
}

export async function getSerialWorkflowHistory(ctx: ProductionAuthContext, serialId: number): Promise<ISerialWorkflowHistoryResponseDTO> {
    const url = buildRestUrl({
        endpoint: RestEndpointsEnum.ProductionSerialHistory,
        params: { serialId: String(serialId) },
    });
    return ky.get(url, { headers: getHeaders(ctx) }).json<ISerialWorkflowHistoryResponseDTO>();
}
